import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroBanners } from "@/mocks/comics";

export default function Hero() {
  const [index, setIndex] = useState(0);
  const count = heroBanners.length;

  const go = useCallback(
    (dir: number) => setIndex((i) => (i + dir + count) % count),
    [count],
  );

  useEffect(() => {
    const timer = setInterval(() => go(1), 5000);
    return () => clearInterval(timer);
  }, [go]);

  return (
    <section className="relative h-[520px] w-full overflow-hidden md:h-[600px]" aria-label="推荐漫画轮播">
      {heroBanners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <img
            src={b.image}
            alt={`91韩漫画 ${b.title} 专题推荐横幅`}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-foreground-950/20" />
        </div>
      ))}

      <div className="container-x relative flex h-full w-full items-center">
        <div className="w-full max-w-2xl pt-16">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-sparkling-line text-primary-300" />
            分类齐全 · 热门韩漫一网打尽
          </p>
          <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            {heroBanners[index].title}
          </h1>
          <p className="mt-3 text-lg font-medium text-background-100 md:text-xl">
            {heroBanners[index].subtitle}
          </p>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200/90">
            {heroBanners[index].desc}
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to={heroBanners[index].link}
              className="btn-primary h-11 px-6 text-sm"
            >
              <i className="ri-play-circle-line text-lg" />
              {heroBanners[index].btn}
            </Link>
            <Link to="/category/all" className="btn h-11 bg-background-50/15 px-6 text-sm text-background-50 backdrop-blur-sm hover:bg-background-50/25">
              全部分类
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => go(-1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/15 text-lg text-background-50 backdrop-blur-sm transition hover:bg-background-50/30 md:left-6"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      <button
        type="button"
        onClick={() => go(1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/15 text-lg text-background-50 backdrop-blur-sm transition hover:bg-background-50/30 md:right-6"
      >
        <i className="ri-arrow-right-s-line" />
      </button>

      <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 gap-2">
        {heroBanners.map((b, i) => (
          <button
            key={b.id}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`切换到第${i + 1}张`}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === index ? "w-8 bg-background-50" : "w-3 bg-background-50/40"
            }`}
          />
        ))}
      </div>
    </section>
  );
}